import React from 'react';
import useOrganization from '../../../hooks/api/useOrganization';
import Button from '../Button';
import { useNestedNavigation } from '../../../utils/appNavigationNames';
import SkeletonLoadingContainer from '../SkeletonLoadingContainer';

export type OrganizationButtonOwnProps = {};

export type OrganizationButtonProps = OrganizationButtonOwnProps;

const OrganizationButton: React.FC<OrganizationButtonProps> = () => {
    const { isLoadingMyOrganization, myOrganization } = useOrganization({});
    const { nestedOrganizationNavigation } = useNestedNavigation();
    return (
        <SkeletonLoadingContainer isLoading={isLoadingMyOrganization || !myOrganization}>
            <Button
                title={myOrganization?.organization?.metadata?.name || 'Filler-Organization'}
                onPress={() => {
                    nestedOrganizationNavigation('root', {});
                }}
                variant="pro-header-button"
                testID={isLoadingMyOrganization ? undefined : 'organization-navigation-button'}
            />
        </SkeletonLoadingContainer>
    );
};

export default React.memo(OrganizationButton);
